var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M27.9751 3.12324C27.6458 1.89323 26.6792 0.926623 25.4492 0.597366C23.2197 0 14.285 0 14.285 0C14.285 0 5.35042 0 3.12324 0.597366C1.89323 0.926623 0.926623 1.89323 0.597366 3.12324C0 5.35042 0 10 0 10C0 10 0 14.6496 0.597366 16.8768C0.926623 18.1068 1.89323 19.0734 3.12324 19.4026C5.35042 20 14.285 20 14.285 20C14.285 20 23.2197 20 25.4468 19.4026C26.6769 19.0734 27.6435 18.1068 27.9727 16.8768C28.5701 14.6496 28.5701 10 28.5701 10C28.5701 10 28.5701 5.35042 27.9727 3.12324H27.9751Z","fill":"black","key":0}),React.createElement("path",{"d":"M11.4276 14.2851L18.8523 10L11.4276 5.71497V14.2851Z","fill":"white","key":1})]);
}

Youtube.defaultProps = {"width":"29","height":"20","viewBox":"0 0 29 20","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
